import React from 'react';
import { GiftIcon } from 'lucide-react';
import type { BundleBonus } from '../../data/babyShowerBundle';
import { formatArs, pricingFlags } from '../../data/babyShowerPricing';
type BundleCardProps = {
  item: BundleBonus;
  slot: string;
};

/**
 * Tarjeta de bono. Las 4 tarjetas comparten exactamente el mismo diseño:
 * portada en un marco 2:3 fijo (sin recortar ni deformar) a la izquierda, texto a la derecha.
 */
export function BundleCard({
  item,
  slot
}: BundleCardProps) {
  return <article className="flex h-full items-center gap-4 rounded-3xl border border-[#EFE4D6] bg-white p-3 shadow-[0_10px_28px_-22px_rgba(139,107,85,0.45)] sm:gap-5 sm:p-4" data-id="element-45" data-mp="lq8gt4ovcd76">
      <div className="flex aspect-[2/3] w-[104px] shrink-0 items-center justify-center overflow-hidden rounded-xl bg-[#FAF0E7] sm:w-[124px]" data-id="element-46" data-mp="qnqiqb4gxs5o">
        <img src={item.image} alt={`Portada: ${item.title}`} data-slot={slot} loading="lazy" className="h-full w-full object-contain" data-id="element-47" data-mp="3u73apunoun94" />
      </div>
      <div className="min-w-0 flex-1" data-id="element-48" data-mp="2xkfq9dl51rie">
        <span className="inline-flex items-center gap-1 rounded-full bg-[#C4E8E6] px-2.5 py-0.5 text-[10.5px] font-extrabold uppercase tracking-[0.06em] text-[#0E7C78] sm:text-[11px]" data-id="element-49" data-mp="2xnk1uw0xnpj3">
          <GiftIcon className="h-3 w-3" strokeWidth={2.25} aria-hidden="true" data-id="element-50" data-mp="2nu35bk9evwbq" />
          {item.badge}
        </span>
        <h4 className="mt-2 font-display text-[17px] font-bold leading-snug text-[#4A3A35] sm:text-[18px]" data-id="element-51" data-mp="2iui93hlmm22p">{item.title}</h4>
        <p className="mt-1 text-[15px] leading-snug text-body" data-id="element-52" data-mp="29w6aoteipzzp">{item.description}</p>

        {pricingFlags.showBonusPrices && <p className="mt-2.5 text-[13.5px] text-body" data-id="element-53" data-mp="24xuyic0r3deb">
            Precio individual:{' '}
            <s className="font-semibold text-[#8B6B55] decoration-[#E74D7A] decoration-2" data-id="element-54" data-mp="1zyiavp2222ao">{formatArs(item.price)}</s>
          </p>}
        {pricingFlags.showFreeToday ? <p className="mt-2 w-fit rounded-lg bg-[#E74D7A] px-3 py-1 font-display text-[13px] font-extrabold uppercase tracking-[0.06em] text-white" data-id="element-55" data-mp="3ub892izghxnv">
            Hoy gratis
          </p> : <span className="mt-3 block h-1 w-8 rounded-full bg-[#F5B4C9]" aria-hidden="true" data-id="element-56" data-mp="1xdssian025ku" />}
      </div>
    </article>;
}